<script>
export default
{
    name: 'layout-outer',

    mounted()
    {

    }
}
</script>

<template>
    <main>
        <div class="outer-background">
            <div class="container">
                <transition name="fade">
                    <router-view>
                    </router-view>
                </transition>
            </div>
        </div>
    </main>
</template>



// WEBPACK FOOTER //
// src/layouts/Outer.vue